import { observable } from 'mobx';

import store from '../store';

class CatalogStore {

    donationItems = observable([]);   
    displayOnly = null;
    selectedDonationItem = observable.box(null);
    recurringByDefault = false;
    processing = observable.box(false); 
    error = observable.box(null); 

    fetchDonationItems() {            
        this.processing.set(true);
        const url = store.netsuiteBaseUrl + '&custom_mode=api';
        const body = {
            action: 'getDonationItems',
            data: {},
        };  
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
        })
        .then(res => res.json())
        .catch(error => {
            this.processing.set(false);
            this.error.set('An unexpected error has occurred.');   
            console.error('Caught error (1): ', error);         
        })
        .then(json => {
            //console.log('Response body (json): ', json);
            if (!json) {
                this.error.set('An unexpected error has occurred.');
                console.error('Received null response body.');                
            } else if (json.status !== 'ok') {
                console.error('Error: received failed status.');
                this.error.set(json.errors[0]);                 
            } else {                         
                if (this.displayOnly) {
                    let displayOnlyItems = [];
                    json.data.items.map(item => {                        
                        if (this.displayOnly.includes(item.values.itemid)) {
                            displayOnlyItems.push(item);
                        }
                        return null;
                    });
                    this.donationItems.replace(displayOnlyItems);
                } else {
                    this.donationItems.replace(json.data.items);                    
                }
                this.selectedDonationItem.set(this.donationItems[0]);
            }            
            this.processing.set(false);
        })  
        .catch(error => {
            this.error.set('An unexpected error has occurred.');   
            console.log('Caught error (2):', error);          
            this.processing.set(false);
        });                    
    }      

}

let catalogStore = new CatalogStore();
export default catalogStore;


// WEBPACK FOOTER //
// ./src/stores/catalogStore.js